import { Box, SxProps, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RefetchButton } from '..';

interface RefetchOnErrorProps {
  onRefetch: () => void;
  sx?: SxProps<Theme>;
}

export const RefetchOnError: React.FC<RefetchOnErrorProps> = ({
  onRefetch,
  sx,
}) => {
  const [t] = useTranslation('shared');
  return (
    <Box textAlign="center" sx={{ mt: 24, ...sx }}>
      <Typography variant="body1" sx={{ mb: 4 }}>
        {t('getDataError')}
      </Typography>
      <RefetchButton onRefetch={onRefetch} />
    </Box>
  );
};
